import { render } from "./CardFlip.vue?vue&type=template&id=e146b1f0&scoped=true"
import script from "./CardFlip.vue?vue&type=script&lang=js"
export * from "./CardFlip.vue?vue&type=script&lang=js"

import "./CardFlip.vue?vue&type=style&index=0&id=e146b1f0&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e146b1f0"]])

export default __exports__